import React, { useState, useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import Formatter from "../../Data/Domain/Formatter";
import Storage from "../../Data/Domain/Storage";
import { message, Checkbox } from "antd";
import InterfaceTable from "../../Table/InterfaceTable";
import "./Permissions.css";
import {
  getPermissionsCountSelector,
  getPermissionsSelector,
} from "../Infrastructure/Permissions.reducer";
import {
  getPermissionsByOwner,
  updatePermission,
} from "../Application/Permissions.bussines";
import { useDispatch } from "react-redux";
import { setPermissions } from "../Infrastructure/Permissions.reducer";
import { CustomCard, Title } from "../../Utils/UI/Text";

const Permissions = () => {
  const permissions = useSelector(getPermissionsSelector);
  const count = useSelector(getPermissionsCountSelector);
  const [values, setValues] = useState({
    page: 0,
    limit: 5,
  });
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const ownerId = useMemo(() => new Storage("id").getItem(), []);

  const fetchData = async (params = {}) => {
    try {
      setLoading(true);
      await getPermissionsByOwner({ ownerId, ...params });
      const shouldNotify = Object.keys(params).some(
        (key) => key !== "page" && key !== "limit"
      );
      if (shouldNotify) {
        message.success("Filtrado");
      }
    } catch (error) {
      message.error("error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData({ page: values.page, limit: values.limit });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleRequest = (newPagination = {}, newFilters = {}, sorter = {}) => {
    const { current = values.page + 1, pageSize = values.limit } = newPagination;
    const updatedValues = {
      page: current - 1,
      limit: pageSize,
    };

    const field_sort = sorter.field;
    const sort =
      sorter.order === "ascend"
        ? "ascending"
        : sorter.order === "descend"
        ? "descending"
        : undefined;

    const clean = Formatter.cleanParamsFromTableToAPI({
      ...newFilters,
      limit: updatedValues.limit,
      page: updatedValues.page,
      field_sort,
      sort,
      dates: [],
    });

    setValues(updatedValues);
    fetchData(clean);
  };
  const handleUpdate = async (userId, permissionKey, access, namePermission) => {
    try {
      setLoading(true);
      const updatedPermissions = permissions.map((user) => {
        if (user.id === userId) {
          return {
            ...user,
            namePermission,
            permissions: user.permissions.map((permission) =>
              permission.key === permissionKey
                ? { ...permission, access: !permission.access }
                : permission
            ),
          };
        }
        return user;
      });
      dispatch(setPermissions(updatedPermissions));

      await updatePermission(userId, {
        key: permissionKey,
        access: !access,
      });
      message.success("Check actualizado");
    } catch (error) {
      message.error("Error al actualizar el check");
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      title: "Usuario",
      dataIndex: "namePermission",
      key: "namePermission",
    },
    {
      title: "Proyecto",
      dataIndex: "project_name",
      key: "project_name",
    },
    {
      title: "Accesos",
      dataIndex: "permissions",
      key: "permissions",
      render: (_, record) => {
        return record.permissions.map((element, index) => (
          <div className="containerAccess" key={index}>
            <div className="flexAccess">
              <div className="columnLeft">{element.key}</div>
              <div className="columnRight">
                <Checkbox
                  key={element.key}
                  checked={element.access}
                  onChange={() =>
                    handleUpdate(record.id, element.key, element.access, record.namePermission)
                  }
                />
              </div>
            </div>
          </div>
        ));
      },
    },
  ];
  return (
    <div className="permissions-page">
      <Title children={"Permisos"} />

      <CustomCard className="permissions-card">
        <div className="permissions-table-wrap">
          <InterfaceTable
            rowKey="id"
            data={permissions}
            columns={columns}
            loading={loading}
            onChange={handleRequest}
            pagination={{
              current: values.page + 1,
              pageSize: values.limit,
              total: count,
              position: ["bottomCenter"],
              showSizeChanger: true,
              showQuickJumper: true,
              pageSizeOptions: ["5", "10", "20", "25", "50", "100"],
              showTotal: (t, [s, e]) => `${s}-${e} de ${t}`,
            }}
          />
        </div>
      </CustomCard>
    </div>
  );
};

export default Permissions;
